/*
* @Author: jiangweiwei
* @Date:   2017-07-27 14:39:48
* @Last Modified by:   Marte
* @Last Modified time: 2017-08-04 10:23:20
*/

'use strict';

angular.module('categoryRelationDirectiveModule', [])
.directive('trsListOpen',["$timeout","$q",function($timeout,$q){
    // Runs during compile
    return {
        // name: '',
        // priority: 1,
        // terminal: true,
        // scope: {}, // {} = isolate, true = child, false/undefined = no change
        // controller: function($scope, $element, $attrs, $transclude) {},
        // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
        restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
        // template: '',
        // templateUrl: '',
        // replace: true,
        // transclude: true,
        // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
        link: function(scope, element, attrs, ctrls) {
            // $timeout(function() {
            //     var elmHeight = element.height();
            //     if(elmHeight>0){
            //         scope.elmHeight = elmHeight;
            //     }
            // }, 1000);
            $timeout(function() {
                var allSpan = element.find('span');
                scope.elmclientWidth = element[0].clientWidth;
                scope.AllHeight = 0;
                if(allSpan.length>0){
                    for(var i=0;i<allSpan.length;i++){
                        scope.AllHeight+= $(allSpan[i]).width();
                    }
                }
            }, 1000);
        }
    };
}]);